import ChooseShop from './ChooseShop.view';

export default ChooseShop;
